export const getCalculateArea = (length?: number, width?: number): number | null => {
  if (!length || !width) return null;
  return Number(length) * Number(width);
};
